module.exports = __webpack_public_path__ + "img/688.0e6458fc.png";